import { reportToCsv, type ReportPayload } from '@finvox/report-engine';

export function downloadCsv(filename: string, data: ReportPayload): void {
  const csv = reportToCsv(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function printReportPdf(opts: {
  orgName: string;
  reportTitle: string;
  titleAr: string;
  periodLabel: string;
  htmlBody: string;
}): void {
  const win = window.open('', '_blank', 'noopener,noreferrer');
  if (!win) return;
  win.document.write(`<!DOCTYPE html>
<html dir="ltr">
<head>
<meta charset="utf-8"/>
<title>${opts.reportTitle}</title>
<style>
  body { font-family: system-ui, sans-serif; margin: 24px; font-size: 12px; }
  .header { display: flex; justify-content: space-between; border-bottom: 2px solid #333; padding-bottom: 12px; margin-bottom: 16px; }
  .header h1 { margin: 0; font-size: 18px; }
  .header .ar { direction: rtl; text-align: right; }
  table { width: 100%; border-collapse: collapse; }
  th, td { border: 1px solid #ccc; padding: 6px 8px; text-align: left; }
  th { background: #f5f5f5; }
  .amount { text-align: right; font-variant-numeric: tabular-nums; }
  @media print { body { margin: 12px; } }
</style>
</head>
<body>
  <div class="header">
    <div>
      <h1>FinVox — ${opts.orgName}</h1>
      <p>${opts.reportTitle}</p>
      <p>${opts.periodLabel}</p>
    </div>
    <div class="ar">
      <h1>فين فوكس — ${opts.orgName}</h1>
      <p>${opts.titleAr}</p>
      <p>${opts.periodLabel}</p>
    </div>
  </div>
  ${opts.htmlBody}
</body>
</html>`);
  win.document.close();
  win.focus();
  win.print();
}

export function reportHtmlForPrint(data: ReportPayload): string {
  if (data.reportType === 'trial_balance') {
    const rows = data.rows
      .map(
        (r) =>
          `<tr><td>${r.code}</td><td>${r.name}</td><td class="amount">${r.debitBalance}</td><td class="amount">${r.creditBalance}</td></tr>`
      )
      .join('');
    return `<table><thead><tr><th>Code</th><th>Name</th><th>Debit</th><th>Credit</th></tr></thead><tbody>${rows}</tbody></table>`;
  }
  return `<pre>${JSON.stringify(data, null, 2)}</pre>`;
}
